<template>
  <v-rect v-for="(cfg, i) in backgroundConfigs" :config="cfg" :key="i" />
  <v-line v-for="(cfg, i) in verticalLineConfigs" :config="cfg" :key="i" />
</template>

<script setup>
import { computed, defineProps, inject } from 'vue';
import { useChartRenderStore } from '../../stores/ChartRenderStore';

const mainChart = inject('chart')
const mainChartRender = inject('chartRender')

const chartRenderStore = useChartRenderStore()

const backgroundConfigs = computed(() => {
  return mainChart.orderedCols.value.map(column => ({
    width: chartRenderStore.columnWidth,
    height: mainChartRender.chartHeight.value,
    fill: column.colour ?? 'white',
    opacity: 0.3,
    x: column.columnIndex * chartRenderStore.columnWidth,
    y: chartRenderStore.timeToPixel(-mainChartRender.negativeVisibleTime.value),
  }))
})

const verticalLineConfigs = computed(() => {
  return mainChart.orderedCols.value.map(column => {
    const w = chartRenderStore.columnWidth * (column.columnIndex + 1)
    return {
      points: [
        w,
        chartRenderStore.timeToPixel(-mainChartRender.negativeVisibleTime.value),
        w,
        mainChartRender.chartHeight.value],
      stroke: '#000',
      strokeWidth: 2,
    }
  })
})
</script>
